var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("LoginHeader"),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.linksContainer },
        [
          _c("Heading", { attrs: { provider: "Google" } }),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.loginItemsContainer },
            _vm._l(_vm.loginItems, function (item, index) {
              return _c("div", { key: item.id, class: _vm.$style.loginItems }, [
                _c("div", { class: _vm.$style.textContainer }, [
                  _c("div", { class: _vm.$style.circle }, [
                    _vm._v(
                      "\n            " + _vm._s(index + 1) + "\n          "
                    ),
                  ]),
                  _vm._v("\n          " + _vm._s(item.text) + "\n        "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.$style.buttonContainer },
                  [
                    _c("ButtonAnchor", {
                      class: _vm.$style.button,
                      attrs: { text: item.linkText, href: item.link },
                    }),
                  ],
                  1
                ),
              ])
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }